export default function getStdLocale(fsLanguageCode) {
  switch (fsLanguageCode) {
    case 'zh':
      return 'zh-Hant'
    case 'zh-hans':
      return 'zh-Hans'
    default:
      return fsLanguageCode
  }
}
